import appLogger from '@/services/logger';
let modulePrefetchPromise: Promise<void> | null = null;
let modulePrefetchAttempted = false;
let cachedCssContent: string | null = null;

async function prefetchModule(): Promise<void> {
  try {
    await import('agentic_chat/AgenticChat');
  } catch (error) {
    appLogger.warn('AIEditsAdapter: Failed to prefetch module:', error);
  }
}

async function prefetchStyles(): Promise<void> {
  try {
    const stylesModule = await import('agentic_chat/styles');
    cachedCssContent = await stylesModule.fetchCssContent();
  } catch (error) {
    appLogger.warn('AIEditsAdapter: Failed to prefetch CSS:', error);
  }
}

export function getCachedCssContent(): string | null {
  return cachedCssContent;
}

export async function prefetchModuleAndStyles(): Promise<void> {
  if (modulePrefetchPromise) {
    return modulePrefetchPromise;
  }

  if (modulePrefetchAttempted) {
    return Promise.resolve();
  }

  modulePrefetchAttempted = true;

  modulePrefetchPromise = (async () => {
    appLogger.info('AIEditsAdapter: Starting module and CSS prefetch');
    await Promise.all([prefetchModule(), prefetchStyles()]);
    appLogger.info('AIEditsAdapter: Module and CSS prefetch complete');
  })();

  return modulePrefetchPromise;
}

export function clearCachedCss(): void {
  cachedCssContent = null;
}

export function resetModulePrefetch(): void {
  modulePrefetchPromise = null;
  modulePrefetchAttempted = false;
}
